import React, { useState } from 'react';
import { FiSave, FiX } from 'react-icons/fi';
import FlowConfigPanel from '../FlowConfigPanel';

export default function SaveFlowModal({ flowName, config, saving, onSave, onClose }) {
  const [name, setName] = useState(flowName || '');
  const [cfg, setCfg]   = useState(config);

  return (
    <div style={{ position:'fixed', inset:0, zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.5)', backdropFilter:'blur(4px)' }}>
      <div style={{ background:'#fff', borderRadius:20, padding:32, maxWidth:560, width:'100%', margin:'0 16px', maxHeight:'90vh', overflowY:'auto', boxShadow:'0 24px 80px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
          <h3 style={{ fontSize:18, fontWeight:700, color:'#0f172a', fontFamily:'Syne,sans-serif' }}>Save Flow</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'#64748b' }}><FiX size={20}/></button>
        </div>

        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>Flow Name</label>
          <input value={name} onChange={e => setName(e.target.value)}
            onKeyDown={e => e.stopPropagation()}
            placeholder="e.g. Banking Support Bot v1"
            style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:10, fontSize:14, fontWeight:600, color:'#0f172a', outline:'none', boxSizing:'border-box' }}/>
        </div>

        <FlowConfigPanel config={cfg} onChange={setCfg}/>

        <div style={{ display:'flex', gap:12, justifyContent:'flex-end', marginTop:20 }}>
          <button onClick={onClose} disabled={saving}
            style={{ padding:'10px 20px', fontSize:13, fontWeight:600, color:'#475569', background:'#f1f5f9', border:'none', borderRadius:10, cursor:'pointer' }}>
            Cancel
          </button>
          <button onClick={() => onSave(name, cfg)} disabled={saving || !name.trim()}
            style={{ padding:'10px 24px', fontSize:13, fontWeight:700, color:'#fff', background: saving||!name.trim() ? '#94a3b8':'#4f46e5', border:'none', borderRadius:10, cursor: saving||!name.trim() ? 'not-allowed':'pointer', display:'flex', alignItems:'center', gap:8 }}>
            {saving ? (
              <><div style={{ width:14, height:14, border:'2px solid #fff3', borderTopColor:'#fff', borderRadius:'50%', animation:'spin 0.8s linear infinite' }}/> Saving...</>
            ) : (
              <><FiSave size={14}/> Save Flow</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
